import React from 'react'
import { Alert } from 'react-bootstrap';

function Alerts(props) {
  const capitalize = (word) =>{
    const lower = word.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  }
  return(
  <>
        {props.Alert && <Alert variant={props.Alert.tpe}>
        <strong>{capitalize(props.Alert.tpe)}</strong> {props.Alert.msg}
        </Alert>}
  </>
  );
}
  

export default Alerts
